// @owners { team: patients-team }
import {
  ActionSheetContext,
  Description,
  Icon,
  InlineAlert,
  Link,
  Row,
  XsPadding,
  XxsPadding,
} from '@alto/design-system';
import React, { useContext, useEffect } from 'react';
import { formatRelativeDate } from '~shared/helpers/date';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { CartMixedAvailabilityActionSheet } from './CartMixedAvailabilityActionSheet';

export const CartMixedAvailabilityAlert = ({ date }: { date: string }) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent({ event: EVENTS.MIXED_AVAILABILITY_ALERT_VIEWED });
  }, [trackEvent]);

  return (
    <>
      <InlineAlert type="warning">
        <Row
          centerVertically
          centerHorizontally
          testID="cart-mixed-availability-alert"
        >
          <Icon
            name="calendar-small"
            type="grey"
          />
          <XxsPadding />
          <Description>{`Available ${formatRelativeDate(date, { abbreviated: true, includeRelative: true })} • `}</Description>
          <Link
            textSize="mini"
            onPress={() => {
              setActiveActionSheet(<CartMixedAvailabilityActionSheet date={date} />);
            }}
          >
            Details
          </Link>
        </Row>
      </InlineAlert>
      <XsPadding />
    </>
  );
};
